"use client";
import {
  __spreadValues
} from "../../../chunk-MMUBH76A.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { CpslButton, CpslDivider, CpslIcon, CpslQrCode, CpslSpinner, CpslText } from "@getpara/react-components";
import { useModalStore, useThemeStore, useUserInfoStore } from "../../stores/index.js";
import { InnerStepContainer, StepContainer, Heading, QRContainer } from "../common.js";
import { useCopyToClipboard, UserIdentifier } from "@getpara/react-common";
import { useCreateAccount } from "../../hooks/useCreateAccount.js";
import { useInternalClient } from "../../../provider/hooks/utils/useInternalClient.js";
const BiometricCreationStep = () => {
  const createAccount = useCreateAccount();
  const para = useInternalClient();
  const appName = useThemeStore((state) => state.appName);
  const webAuthURLForCreate = useModalStore((state) => state.webAuthURLForCreate);
  const iFrameUrl = useModalStore((state) => state.iFrameUrl);
  const isPasskeySupported = useModalStore((state) => state.isPasskeySupported);
  const authInfo = useUserInfoStore((state) => state.getAuthInfo());
  const [isCopied, copy] = useCopyToClipboard();
  const handleCopy = () => {
    copy(webAuthURLForCreate);
  };
  const isBoth = !!webAuthURLForCreate && !!iFrameUrl;
  return /* @__PURE__ */ jsxs(StepContainer, { $wide: true, children: [
    /* @__PURE__ */ jsxs(InnerStepContainer, { children: [
      /* @__PURE__ */ jsx(Heading, { variant: "headingS", weight: "bold", children: para.isExternalWalletAuth ? `Finish setup for your${appName ? ` ${appName}` : ""} wallet` : isBoth ? "Secure Your Account" : "Create Passkey" }),
      /* @__PURE__ */ jsx(UserIdentifier, __spreadValues({}, authInfo)),
      /* @__PURE__ */ jsx(CpslText, { variant: "bodyS", color: "secondary", weight: "medium", children: isBoth ? "Choose a password or set up a passkey" : "Your Passkey keeps your account safe." })
    ] }),
    /* @__PURE__ */ jsxs(InnerStepContainer, { children: [
      isPasskeySupported ? /* @__PURE__ */ jsxs(CpslButton, { fullWidth: true, onClick: createAccount.withPasskey, children: [
        /* @__PURE__ */ jsx(CpslIcon, { slot: "start", icon: "key" }),
        isBoth ? "Create Passkey" : "Create"
      ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(CpslText, { weight: "semiBold", children: "Scan with your mobile device" }),
        /* @__PURE__ */ jsx(QRContainer, { children: !webAuthURLForCreate ? /* @__PURE__ */ jsx(CpslSpinner, { size: 100 }) : /* @__PURE__ */ jsx(CpslQrCode, { url: webAuthURLForCreate }) }),
        /* @__PURE__ */ jsxs(CpslButton, { size: "small", variant: "ghost", onClick: handleCopy, children: [
          /* @__PURE__ */ jsx(CpslIcon, { slot: "start", icon: isCopied ? "check" : "copy" }),
          isCopied ? "Copied" : "Copy Link"
        ] })
      ] }),
      isBoth && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(CpslDivider, { children: "or" }),
        /* @__PURE__ */ jsxs(CpslButton, { fullWidth: true, onClick: createAccount.withPassword, children: [
          /* @__PURE__ */ jsx(CpslIcon, { slot: "start", icon: "passcode" }),
          "Choose Password"
        ] })
      ] })
    ] })
  ] });
};
export {
  BiometricCreationStep
};
